<mat-form-field [formGroup]="paramsGroup" class="text-filter">
  <mat-label>Value</mat-label>
  <input matInput type="text" formControlName="value" />
  <div class="form-field-badge" matTextSuffix>A-Z</div>
  @if (paramsGroup.get('value')?.hasError('required')) {
    <mat-error>This field is required</mat-error>
  }
</mat-form-field>
